import { render } from "./ColorsContent.vue?vue&type=template&id=ceeb0a58"
import script from "./ColorsContent.vue?vue&type=script&lang=js"
export * from "./ColorsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__